<template>
  <v-layout align-end justify-end row wrap>
    <v-flex xs12>
      <v-layout v-if="bookingForm.loading == true" row style="width: 100%" justify-end align-end>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-layout>
      <v-layout
        v-if="bookingForm.loading == false"
        row
        style="width: 100%"
        justify-end
        align-center
      >
        <v-layout align-end pr-1>
          <BookTripETARoute :bookingForm="bookingForm" />
        </v-layout>
        <v-flex shrink>
          <v-row>
            <v-flex px-1>
              <v-btn
                submit
                v-if="!updateMode || updateMode == null"
                @click="clear"
                class="text-none"
                small
                color="white"
              >Clear</v-btn>
            </v-flex>
            <v-flex px-1>
              <v-btn
                submit
                v-if="(!updateMode || updateMode == null) && !backdate"
                @click="book"
                class="text-none"
                dark
                small
                color="#8268FC"
              >Make Booking</v-btn>
              <v-btn
                submit
                v-if="(!updateMode || updateMode == null) && backdate"
                @click="backdateTrip"
                class="text-none"
                dark
                small
                color="#8268FC"
              >Backdate</v-btn>
            </v-flex>
            <v-flex px-1>
              <v-btn
                v-if="bookingForm.booking.state != null && bookingForm.booking.state != 'cancelled' && bookingForm.booking.state != 'completed' "
                dark
                color="red lighten-2"
                @click="cancelDialog = true"
                class="text-none"
                small
              >Cancel Booking</v-btn>
            </v-flex>
            <v-flex px-1>
              <v-btn
                submit
                dark
                color="#8268FC"
                v-if="bookingForm.booking.state"
                @click="update"
                class="text-none"
                small
              >Update Booking</v-btn>
            </v-flex>
            <v-flex px-1>
              <v-btn
                v-if="largeMode && bookingForm.booking.state != null && bookingForm.booking.state != 'accepted'"
                dark
                color="orange"
                @click="showChangeUser"
                class="text-none"
                small
              >Change User</v-btn>
            </v-flex>
          </v-row>
        </v-flex>
        <v-btn v-if="!largeMode" icon ripple @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
      <p style="color: red; margin-left: 18px;">{{bookingForm.errors.error}}</p>
    </v-flex>
    <v-dialog persistent v-model="cancelDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Cancel Booking</span>
        </v-card-title>
        <v-flex pa-4>
          <v-row>
            <v-flex shrink>
              <v-checkbox
                v-if="bookingForm.booking.card_payment_type == 'prepaid'"
                label="Charge Cancellation Fee"
                v-model="cancellationFee"
              ></v-checkbox>
            </v-flex>
            <v-flex shrink pl-5>
              <v-checkbox
                v-if="bookingHasOtherTripToCancel"
                :label="'Cancel ' + nameForOtherTrip + ' trip'"
                v-model="cancelOtherTrip"
              ></v-checkbox>
            </v-flex>
          </v-row>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat text @click="cancelDialog = false">Back</v-btn>
          <v-btn flat text @click="cancel">Confirm Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "BookRideOptions",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    SimpleTextAreaInput,
    BookTripETARoute
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false
    },
    largeMode: {
      type: Boolean,
      default: true
    },
    backdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      cancelDialog: false,
      cancellationFee: false,
      cancelOtherTrip: false
    };
  },
  computed: {
    nameForOtherTrip: function() {
      if (
        this.bookingForm.booking.cart.outboundBookingId ==
        this.bookingForm.booking.id
      ) {
        return "Return";
      } else {
        return "Outbound";
      }
    },
    bookingHasOtherTripToCancel: function() {
      if (this.bookingForm.booking.cart == null) {
        return false;
      }

      if (
        this.bookingForm.booking.cart.outboundBookingId ==
        this.bookingForm.booking.id
      ) {
        if (this.bookingForm.booking.cart.returnBookingId != null) {
          if (
            this.bookingForm.booking.cart.returnState != "completed" &&
            this.bookingForm.booking.cart.returnState != "cancelled"
          ) {
            return true;
          }
        }
      } else {
        if (
          this.bookingForm.booking.cart.outboundState != "completed" &&
          this.bookingForm.booking.cart.outboundState != "cancelled"
        ) {
          return true;
        }
      }

      return false;
    }
  },
  methods: {
    showChangeUser: function() {
      this.$emit("change", null);
      console.log("Show change user");
    },
    expand: function() {
      this.$emit("expand", null);
    },
    close: function() {
      this.$emit("close", null);
    },
    book: function() {
      this.$emit("book", null);
    },
    backdateTrip: function() {
      this.$emit("backdate", null);
    },
    update: function() {
      this.$emit("update", null);
    },
    cancel: function() {
      this.cancelDialog = false;
      this.$emit("cancel", {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip
      });
    },
    clear: function() {
      this.bookingForm.clear();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
